import React from 'react';
import { Link } from 'react-router-dom';
import { GrMail } from "react-icons/gr";
import { IoLogoGithub } from "react-icons/io";
import { BsLinkedin } from "react-icons/bs";
import "../introduction.css";

const contact = (props) => {

    const render_tabs = props.tabs.map((tab)=> {
        if (tab.index === 7) {
            const links = tab.options.map((option)=> {
                let asset;
                if (option.title === "Gmail") {
                    asset = <GrMail color='white' size={70}/>
                }
                else if (option.title === "GitHub") {
                    asset = <IoLogoGithub color='white' size={70} />
                }
                else {
                    asset = <BsLinkedin color='white' size={70} />
                }
                return(
                    <Link to={option.to} className='contact_tab center flex_column'>
                        <div className='tab_asset center'>
                            {asset}
                        </div>
                        <div className='tab_description center'>
                            {option.line}
                        </div>
                        <div className='tab_title center'>
                            {option.title}
                        </div>
                    </Link>
                )
            })
            return(
                <div className='link_tab center flex_column' id={`tab-${tab.index}`}>
                    <div className='tab_section center'>
                        {links[0]}
                        {links[1]}
                    </div>
                    <div className='tab_section center'>
                        {links[2]}
                    </div>
                </div>
            )
        }}
    )

    return (
        <div id='me_contact'>
            <div className='container center' style={{flexWrap: "wrap"}}>
                {render_tabs}
            </div>
            <div className='poster_right'>
                <div className='poster'>
                    Contact me
                    <div className='poster_hr'/>
                    <div className='poster_subheading'>
                        Contact and network with me.
                    </div>
                </div>
            </div>
        </div>
    )
}

export default contact;